import DashboardPaper from "../../components/common/DashboardPaper";
import { SECTIONS, type Missing, type SectionKey } from "./validation";

export default function SectionNav({ section, attempted, shown, stepCount, onOpen }: {
  section: number;
  attempted: ReadonlySet<SectionKey>;
  shown: Missing[];
  stepCount: number | undefined;
  onOpen: (index: number) => void;
}) {
  return (
    <DashboardPaper sx={{ flex: "1 1 240px", maxWidth: 280, p: 1 }}>
      <nav aria-label="Sections" className="flex flex-col gap-0.5">
        {SECTIONS.map((s, i) => {
          const n = attempted.has(s.key) ? shown.filter((m) => m.section === s.key).length : 0;
          const isReview = s.key === "review";
          const done = !isReview && attempted.has(s.key) && n === 0;
          const sub = isReview ? `${stepCount ?? "…"} steps` : n ? `${n} missing` : done ? "Complete" : "";
          return (
            <button
              key={s.key} type="button" onClick={() => onOpen(i)} aria-current={section === i ? "step" : undefined}
              className={`flex min-h-[52px] cursor-pointer items-center gap-3 rounded-lg p-3 text-left ${section === i ? "bg-brand-50 dark:bg-brand-500/15" : "hover:bg-gray-50 dark:hover:bg-white/5"}`}
            >
              <span className={`flex h-6 w-6 flex-none items-center justify-center rounded-full text-xs font-semibold ${done ? "bg-success-50 text-success-700" : n ? "bg-error-50 text-error-700" : "bg-gray-100 text-gray-600"}`}>
                {done ? "✓" : i + 1}
              </span>
              <span className="flex min-w-0 flex-col">
                <span className={`text-sm font-medium ${section === i ? "text-brand-500" : "text-gray-700 dark:text-gray-300"}`}>{s.label}</span>
                <span className={`text-xs ${n ? "text-error-700" : "text-gray-500"}`}>{sub}</span>
              </span>
            </button>
          );
        })}
      </nav>
    </DashboardPaper>
  );
}
